import jsxElem from "jsx-no-react";

const UIFeedback = {
    spinner(e) {
        e.currentTarget.setAttribute('disabled', true);
        
        // Store reference to the button element
        this._currentButton = e.currentTarget;
        
        const iconSpan = e.currentTarget.querySelector('.label-icon span');
        if (iconSpan) {
            iconSpan.className = 'fas fa-circle-notch fa-spin';
        }
        
        const textNodes = Array.from(e.currentTarget.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
        if (textNodes.length > 0) {
            textNodes[0].textContent = ' Please wait...';
        } else {
            e.currentTarget.appendChild(document.createTextNode(' Please wait...'));
        }
    },
    
    timeout(e) {
        const buttonElement = e?.currentTarget || this._currentButton;
        if (!buttonElement) return;
        
        const iconSpan = buttonElement.querySelector('.label-icon span');
        if (iconSpan) {
            iconSpan.className = 'fa fa-exclamation-triangle';
        }
        
        const textNodes = Array.from(buttonElement.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
        if (textNodes.length > 0) {
            textNodes[0].textContent = ' Timeout Error';
        } else {
            buttonElement.appendChild(document.createTextNode(' Timeout Error'));
        }
        
        buttonElement.classList.add('btn-danger');
        buttonElement.classList.remove('btn-primary');

        setTimeout(() => {
            this.resetForm(e, 'Save', 'fas fa-save');
        }, 3000);
    },
    
    resetForm(e, label = 'Save', icon = 'fas fa-save') {
        const buttonElement = e?.currentTarget || this._currentButton;
        if (!buttonElement) return;
        
        const iconSpan = buttonElement.querySelector('.label-icon span');
        if (iconSpan) {
            iconSpan.className = icon;
        }
        
        const textNodes = Array.from(buttonElement.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
        if (textNodes.length > 0) {
            textNodes[0].textContent = ` ${label}`;
        } else {
            buttonElement.appendChild(document.createTextNode(` ${label}`));
        }
        
        buttonElement.classList.add('btn-primary');
        buttonElement.classList.remove('btn-danger');
        buttonElement.removeAttribute('disabled');
        
        // Clear the stored reference
        this._currentButton = null;
    }
};

export {
    UIFeedback
};